import { Component, Inject } from '@angular/core';
import { SidebarNavMenuItem } from '../../../../decorators/sidebar-nav-menu-item';
import { COURSE_ENTITY_SERVICE_TOKEN } from '../../../../injection-tokens/entity-service-tokens';
import { ICourseEntityService } from '../../../../interfaces/entities/course-entity-service.interface';
import { CourseEntity } from '../../../../models/entities/course';
import { CourseEntityService } from '../../../../services/entity-services/course-entity.service';
import { ErrorHandlerService } from '../../../../decoration-base/error-handler.service';
import { Router } from '@angular/router';
import { NotificationService } from '../../../../services/notification.service';

@SidebarNavMenuItem({
  route: '/courses',
  faIcon: 'fa-book',
  name: 'Courses',
  order:3000,
  roles:['admin','trainer']
})
@Component({
  selector: 'app-course-list',
  templateUrl: './course-list.component.html',
  styleUrls: ['./course-list.component.css']
})
export class CourseListComponent {

  courses: CourseEntity[] = [];
  newCourse: CourseEntity = new CourseEntity();
  viewMode: 'detail' | 'card' = 'detail';
selectedCourseId: string | undefined = undefined;

  constructor(
    @Inject(COURSE_ENTITY_SERVICE_TOKEN) public courseService: ICourseEntityService,
    private errorHandler: ErrorHandlerService,
    private router: Router,
    private notification: NotificationService
  ) {
  }

  ngOnInit() {
    // get all courses
    this.loadCourses();
  }

  loadCourses(): void {
    this.errorHandler.tryExecuteAsync(async () => {
      this.courses = this.courseService.getAllCourses();
    }, 'loadCourses');
  }

  // to add a new course
  openAddCourse() {
    // TODO: Implement routing to course creator component later.
    this.notification.notify(`Implement routing to course creator component later`, "warning", 3000);
  }

  // edit course details
  editCourse(course: CourseEntity) {
    // TODO: Implement routing to course creator(edit-mode) component later.
    this.notification.notify('Implement routing to course creator(edit-mode) component later', "warning", 3000);
  }

  // to change the view mode
  onViewChange(value: string) {
    this.viewMode = value as 'detail' | 'card';
  }

  // get lab count for a course
  getLabCount(course: CourseEntity): number {
    return course.labs ? course.labs.length : 0;
  }

  // get vm image summary
  getVMImageSummary(course: CourseEntity): string {
    const vm = course.vmImage;
    if (vm && vm.cloudProviderData && vm.cloudProviderData.provider) {
      return `${vm.cloudProviderData.provider} - ${vm.softwareData.os || 'N/A'}`;
    }
    return 'Not configured';
  }

  // navigate to course details
  viewCourseDetails(course: CourseEntity) {
    this.router.navigate(["/course", course.id]);
  }

  // to show elcipse menu
  
    toggleMenu(event: Event, course: CourseEntity): void {
      if (this.selectedCourseId != course.id)
        this.selectedCourseId = course.id;
      else
        this.selectedCourseId = undefined;
    }
  
  }
  

